var cachedLocation = require('./cached-location-service');

module.exports = {
  getDefaultLocation: function() {
    var coordinates;

    if (!cachedLocation.isEmpty()) {
      coordinates = cachedLocation.get();
    } else {
      try {
        coordinates = JSON.parse(bookedby.staticData.storeGroupSettings.defaultLocation);
      } catch (e) {
        coordinates = {
          lat: 30.561,
          lng: -97.691
        }
      }
    }

    return coordinates;
  },
  updateCachedLocation: function(mapCenter) {
    cachedLocation.set(mapCenter);
  }
};